module.exports = __webpack_public_path__ + "static/media/stopwatch.d58d2417.svg";